import { useState } from 'react';
import { MarkdownBlock } from '@/features/chat-messages/components/markdown-block';
import { TestSupplierDetailDrawer } from '@/features/chat-messages/components/supplier/supplier-detail/supplier-detail';
// import { ChatInputBarV2 } from '@/features/chat-messages/components/chat-input-bar';
import { PagePath } from '@/routes/paths';
import { messageCreatePost } from '@/services/swagger/easourcing/SessionService';
import { Button } from '@leadsnavi/ui-kit';
import { generatePath, useNavigate } from 'react-router';
import InquiryToggle from '@/components/inquiry-toggle';
// import { TestTable } from '@/features/chat-messages/components/supplier/test-table';
import { GoogleStreetViewDialogExample } from '@/common/base/google-street-view-dialog';
import { SupplierTable } from '@/features/chat-messages/components/supplier/supplier-table';
import { ChartInput } from '@/features/chat-messages/components/input';
import { CompanyRow } from '@/features/chat-messages/components/supplier/type';
import { TableDemo } from '@/features/demo/components/table-demo';
import { SupplierSelectionBar } from '@/features/chat-messages/components/base/supplier-selection-bar';
import { Skeleton } from '@/common/base/skeleton';
import { AiAgentLogo } from '@/features/supplier-agent';
import { InquiryTaskStatusTag } from '@/common/biz/status-tag';

export const DemoPage = () => {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
  return (
    <div className="overflow-auto  p-4">
      <InquiryTaskStatusTag status="running" />
      <InquiryTaskStatusTag status="completed" />
      <InquiryTaskStatusTag status="paused" />
      // AI 消息
      <AiAgentLogo />
      // 用户消息
      <AiAgentLogo unreadCount={10} />
      {/* <SupplierAgentChat /> */}
      <div>
        <Skeleton className="h-4 w-full animate-pulse" />
        <Skeleton className="h-4 w-full animate-pulse" />
      </div>
      <TableDemo />
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4">Chat Input Bar Demo111</h2>
        <div className="mb-4">
          <Button onClick={() => setToggle(!toggle)}>Toggle State: {toggle ? 'B Component' : 'A Component'}</Button>
        </div>
        {/* <ChatInputBarV2 toggle={toggle} /> */}
      </div>
      <InquiryToggle isActive={toggle} />
      <div className="w-full h-10"></div>
      <SupplierSelectionBar selectedCount={100} onClose={() => {}} onSendInquiry={() => {}} />
      <TestSupplierDetailDrawer companyId="f95ba1c1-e550-4fad-be21-67fd44ea3225" />
      <TestSupplierDetailDrawer companyId="d032c3bd-179a-4a02-b882-bb8d77dda146" />
      <TestSupplierDetailDrawer companyId="c376f8e6-6df9-4c17-8724-c9bf0793c465" />
      <TestSupplierDetailDrawer
        companyId="a667c678-7d0b-4bd6-80f2-f0782eafc056_cortinapoland.pl"
        description="图片比较多的公司"
      />
      <TestSupplierDetailDrawer companyId="e4f5acf2-c1ae-4eb6-9dad-92beeda19f92" description="有位置的公司" />
      <TestSupplierDetailDrawer companyId="2b829ea0-7af5-4e30-a753-66103c06cb90" description="没有合并公司信息的公司" />
      <TestSupplierDetailDrawer companyId="9ef38a4c-ded1-4768-86c3-d8cd8b38e936" description="两种 record 公司" />
      <TestSupplierDetailDrawer
        companyId="9ef38a4c-ded1-4768-86c3-d8cd8b38e936"
        description="行业字段有逗号问题的公司"
      />
      <TestSupplierDetailDrawer
        companyId="9ef38a4c-ded1-4768-86c3-d8cd8b38e936"
        description="买家地图缺少国家 key 不一致问题"
      />
      <TestSupplierDetailDrawer
        companyId="9ef38a4c-ded1-4768-86c3-d8cd8b38e936"
        description="提单贸易详情与外贸通不一致，需修改"
      />
      <TestSupplierDetailDrawer companyId="649f3235-2d34-4ff2-bfbf-0ffcead0ef8d" description="街景地图" />
      <div>测试 skill</div>
      <GoogleStreetViewDialogExample />
      <MarkdownBlock markdown="Hello, **World**!" />
      <div className="p-4 border border-red-400">
        <div>
          <Button
            onClick={async () => {
              const res = await messageCreatePost({
                question: '帮我找一些LED灯珠公司',
              });
              if (res.data.sessionId) {
                navigate(
                  generatePath(PagePath.chat, {
                    sessionId: res.data.sessionId,
                  })
                );
              }
            }}
          >
            创建新的会话
          </Button>
        </div>
      </div>
      <SupplierTable
        isKeywordLoading={false}
        isAiSummaryLoding={false}
        showSkeleton={true}
        suppliers={[]}
        onDetailClick={id => {
          console.log(id);
        }}
        selectFilter={{
          includeIds: [],
        }}
        onSelectChange={() => {}}
        onSelectAllClick={() => {}}
      />
      <SupplierTable
        isKeywordLoading={true}
        isAiSummaryLoding={true}
        showSkeleton={false}
        suppliers={[
          {
            companyId: '123',
            name: 'LED灯珠公司',
            standardCountry: 'PL',
          } as CompanyRow,
        ]}
        onDetailClick={id => {
          console.log(id);
        }}
        selectFilter={{
          includeIds: [],
        }}
        onSelectChange={() => {}}
        onSelectAllClick={() => {}}
      />
      <div>
        <ChartInput isSending={false} isResponding={false} />
        <ChartInput isSending={true} isResponding={false} />
        <ChartInput isSending={false} isResponding={true} />
      </div>
    </div>
  );
};
